module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_3_2-c4f355be56a312d463e81c662d7c00c5.png";